import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TransactionsService } from '../../services/transactions.service';
import { GetTransactions, GetTransactionsFailure, GetTransactionsSuccess } from '../actions/transactions.actions';
import { Transaction } from '../../models/transaction';

@Injectable()
export class TransactionsEffects {
    getTransactions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetTransactions),
            switchMap((action: { pageNumber: number; pageSize: number; sort: {
                    [key: string]: any
                };
                filter?: {
                    [key: string]: any;
                }; searchTerm: string; fromDate?: string; toDate?: string }) => {
                return this.transactionsService.getTransactions(
                    action.pageNumber,
                    action.pageSize,
                    action.searchTerm,
                    action.sort,
                    action.filter,
                    action.fromDate,
                    action.toDate).pipe(
                    switchMap((res: {
                        data: Array<Transaction>;
                        totalItems: number;
                    }) => {
                        return of(GetTransactionsSuccess({ list: res.data, total: res.totalItems }));
                    }),
                    catchError((error: Error) => of(GetTransactionsFailure(error)))
                );
            })
        )
    );

    constructor(private actions$: Actions, private transactionsService: TransactionsService) {}
}
